import React, { useState, useEffect, useReducer } from "react";
// import axios from "axios";
import Swal from 'sweetalert2';
import { apiPhp, formatNumber } from "../../../utils/Common";
import MyLoader from "../../sharecomponents/MyLoader";
import { Table, Button, Modal } from "semantic-ui-react";
import TablaActividades from "./TablaActividades";
import TablaCosecha from "./TablaCosecha";
import styles from './css/inventario_campo.module.css';

const modalReducer = (state, action) => {
  switch (action.type) {
    case "close":
      return { open: false };
    case "open":
      return { open: true, size: action.size, data: action.data };
    default:
      throw new Error("Unsupported action...");
  }
}

export const InventarioCampo = (props) => {
  const [inventario, setInventario] = useState([]);
  // -- loader
  const [loader, updateLoader] = useState(false);

  // const [filter, setFilter] = useState('');
  // const [valvula, setValvula] = useState(null);

  useEffect(() => {
    getInventario();
  }, []);

  // React Reducer
  const [state, dispatch] = useReducer(modalReducer, {
    open: false,
    size: undefined,
    data: null,
  });
  // -- capturamos el cambio del state del useReducer
  const { open, size, data } = state;
  if ( data ) {
    console.log( data );
  }

  const [mdlState, mdlDispatch] = useReducer(modalReducer, { open: false, data: null });


  async function getInventario() {
    updateLoader(true);
    const result = await apiPhp.get('get_inventario');
    setInventario( result.data.inventario );
    updateLoader( false );
  }

  const autorizar = async (inv, action) => {
    console.log( inv );
    let configAction = {
      text: '',
      textConfirm: '',
      endpoint: '',
    }

    switch (action) {
      case 'autorizar':
        configAction.text = '¿Seguro de Autorizar el plan ' + inv.plan_siembra +
        ' para Descarga??';
        configAction.textConfirm = 'Autorizar';
        configAction.endpoint = 'autorizar_descarga';
        break;

      case 'no_autorizar':
        configAction.text = '¿Seguro de No Autorizar el plan ' + inv.plan_siembra +
        ' para Descarga??';
        configAction.textConfirm = 'No Autorizar';
        configAction.endpoint = 'no_autorizar_descarga';
        break;
    };
    
    Swal.fire({
      title: 'Info',
      text: configAction.text,
      showCancelButton: true,
      confirmButtonText: configAction.textConfirm
    }).then(async result => {
      if ( result.value ) {
        updateLoader( true );
        const result = await apiPhp.post(configAction.endpoint, {
          uuid: inv.uuid,
        });
        console.log( result.data );
        updateLoader( false );
        getInventario();
      }
    });
  }

  /**
   * Custom Style
   */
  const cellHeader = {
    textAlign: "center",
    background: "rgb(111, 45, 30)",
    color: "#fff",
    fontweight: "bold",
    fontsize: "16px",
  };

  const modalHeader = {
    background: "rgb(111, 45, 30)",
    color: "#fff",
  };

  return (
    <div className="w-full p-3 right-0">
      <div className="bg-white border rounded shadow-xl">
        <div className="border-b rounded-t p-3 bg-orange-900">
          <h5 className="font-bold uppercase text-white">
            Inventario de Campo
          </h5>
          <p className="text-white text-sm">Visión de los Planes en Campo</p>
        </div>
        <div className="p-5 rounded-b">
          <Table striped celled={true} size="small">
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell style={cellHeader}>
                  Plan de Siembra
                </Table.HeaderCell>
                <Table.HeaderCell style={cellHeader}>Rancho</Table.HeaderCell>
                <Table.HeaderCell style={cellHeader}>Válvula</Table.HeaderCell>
                <Table.HeaderCell style={cellHeader}>
                  Cantidad Flores
                </Table.HeaderCell>
                <Table.HeaderCell style={cellHeader}>
                  Cama Inicial
                </Table.HeaderCell>
                <Table.HeaderCell style={cellHeader}>
                  Cama Final
                </Table.HeaderCell>
                <Table.HeaderCell style={cellHeader}>Acciones</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {inventario.map((inv, i) => {
                return (
                  <Table.Row key={i}>
                    <Table.Cell style={{padding: '0'}}>
                      <span className={styles.plan}>{inv.plan_siembra}</span>
                      {inv.estatus_descarga === 'DESCARGAR' && 
                        <div className={styles.estatus_des}>
                          DESCARGAR
                          <button className="ui positive small button"
                                  disabled={inv.autorizado_desc ? true : false}
                                  onClick={ () => autorizar(inv, 'autorizar') }
                                  style={{marginLeft: '10px'}}>Autorizar</button>
                          <button className="ui negative small button"
                                  onClick={ () => autorizar(inv, 'no_autorizar') }
                                  style={{marginLeft: '10px'}}>No Autorizar</button>
                        </div>
                      }
                    </Table.Cell>
                    <Table.Cell style={{ textAlign: "center" }}>
                      {inv.rancho}
                    </Table.Cell>
                    <Table.Cell style={{ textAlign: "center" }}>
                      {inv.valvula}
                    </Table.Cell>
                    <Table.Cell style={{ textAlign: "right" }}>
                      {formatNumber(inv.cantidad_flores)}
                    </Table.Cell>
                    <Table.Cell style={{ textAlign: "center" }}>
                      {inv.cama_inicial} ({inv.cama_m2_inicial} m2)
                    </Table.Cell>
                    <Table.Cell style={{ textAlign: "center" }}>
                      {inv.cama_final} ({inv.cama_m2_final} m2)
                    </Table.Cell>
                    <Table.Cell
                      className="center aligned"
                      style={{ width: "270px" }}
                    >
                      <Button
                        size="small"
                        onClick={() => dispatch({ type: "open", data: inv })}
                      >
                        Actividades
                      </Button>
                      <Button size="small"
                        onClick={() => mdlDispatch({ type: 'open', data: inv })}>Cosecha</Button>
                    </Table.Cell>
                  </Table.Row>
                );
              })}
            </Table.Body>
          </Table>
        </div>
      </div>
      {/** loading **/}
      {loader && <MyLoader />}

      {/** Modales  */}
      <Modal
        size={size}
        open={open}
        onClose={() => dispatch({ type: "close" })}
      >
        <Modal.Header style={modalHeader}>Actividades Realizadas</Modal.Header>
        <Modal.Content>
            { data && 
                <TablaActividades uuid={data.uuid} plan={data.plan_siembra} />
            }
        </Modal.Content>
        <Modal.Actions>
          <Button
            color="grey"
            onClick={() => dispatch({ type: "close", data: null })}
          >
            Cerrar Ventana
          </Button>
        </Modal.Actions>
      </Modal>

      {/* Modal para la vista de cosecha realizada */}
      <Modal size="small" open={mdlState.open}
             onClose={() => mdlDispatch({ type: 'close' })}>
        <Modal.Header style={modalHeader}>Cosecha Generada</Modal.Header>
        <Modal.Content>
            { mdlState.data && 
                <TablaCosecha uuid={mdlState.data.uuid} plan={mdlState.data.plan_siembra } />
            }
        </Modal.Content>
        <Modal.Actions>
          <Button
            color="grey"
            onClick={() => mdlDispatch({ type: "close", data: null })}
          >
            Cerrar Ventana
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default InventarioCampo;
